import CloudscapePagination from "@cloudscape-design/components/pagination"

interface PaginationProps {
  currentPage: number
  pageCount: number
  hasMore?: boolean
  loading?: boolean
  onPageChange: (page: number) => void
  onNext: () => void
  onPrevious: () => void
}

export default function Pagination({
  currentPage,
  pageCount,
  hasMore = false,
  loading = false,
  onPageChange,
  onNext,
  onPrevious,
}: PaginationProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        padding: "8px 0",
      }}
    >
      <CloudscapePagination
        currentPageIndex={currentPage}
        pagesCount={pageCount}
        openEnd={hasMore}
        disabled={loading}
        ariaLabels={{
          previousPageLabel: "Previous",
          nextPageLabel: "Next",
        }}
        onChange={({ detail }) => {
          const nextPage = detail.currentPageIndex
          if (nextPage === currentPage + 1) {
            onNext()
          } else if (nextPage === currentPage - 1) {
            onPrevious()
          } else {
            onPageChange(nextPage)
          }
        }}
      />
    </div>
  )
}
